import cash from "cash-dom";
import Pristine from "pristinejs";
import Toastify from "toastify-js";

(function (cash) {
  // Show or hide global event listener
  let events = [];

  // Get highest z-index
  function getHighestZindex() {
    let zIndex = 9999;
    cash(".modal").each(function () {
      if (
        cash(this).css("z-index") !== "auto" &&
        cash(this).css("z-index") > zIndex
      ) {
        zIndex = parseInt(cash(this).css("z-index"));
      }
    });

    return zIndex;
  }

  // Get scrollbar width
  function getScrollbarWidth(el) {
    return window.innerWidth - cash(el)[0].clientWidth;
  }

  // Show modal with z-index
  function show(el) {
    if (!cash("[data-modal-replacer='" + cash(el).attr("id") + "']").length) {
      // Move modal element to body
      cash(
        '<div data-modal-replacer="' + cash(el).attr("id") + '"></div>'
      ).insertAfter(el);
      cash(el).css({
        "margin-top": 0,
        "margin-left": 0,
      });
      cash(el).attr("aria-hidden", false).appendTo("body");

      // Show modal by highest z-index
      setTimeout(() => {
        cash(el)
          .addClass("show")
          .css("z-index", getHighestZindex() + 1);
      }, 200);

      // Setting up modal scroll
      cash("body")
        .css(
          "padding-right",
          parseInt(cash("body").css("padding-right")) +
            getScrollbarWidth("html") +
            "px"
        )
        .addClass("overflow-y-hidden");
      cash(".modal").removeClass("overflow-y-auto").css("padding-left", "0px");
      cash(el)
        .addClass("overflow-y-auto")
        .css("padding-left", getScrollbarWidth(el) + "px")
        .addClass(cash(".modal.show").length ? "modal-overlap" : "");

      // Trigger callback function
      events.forEach(function (val, key) {
        if (
          cash(el).attr("id") == cash(val.el).attr("id") &&
          val.event == "on.show"
        ) {
          events[key].triggerCallback = true;
        }
      });

      // Init form if has
      if (
        cash(el).attr("data-init-form") == "true"
      ) {
        console.log('initForm');
        let component = cash(el).attr("data-component");
        let component_index = cash(el).attr("data-component-index");
        let component_function = cash(el).attr("data-function");
        initForm(el,component,component_index,component_function);
      }
    }
  }

  // Hide modal & remove modal scroll
  function hide(el) {
    if (cash(el).hasClass("modal") && cash(el).hasClass("show")) {
      let transitionDuration =
        parseFloat(cash(el).css("transition-duration").split(",")[1]) * 1000;
      cash(el).attr("aria-hidden", true).removeClass("show");

      setTimeout(() => {
        cash(el)
          .removeAttr("style")
          .removeClass("modal-overlap")
          .removeClass("overflow-y-auto");

        // Add scroll to highest z-index modal if exist
        cash(".modal").each(function () {
          if (parseInt(cash(this).css("z-index")) === getHighestZindex()) {
            cash(this)
              .addClass("overflow-y-auto")
              .css("padding-left", getScrollbarWidth(this) + "px");
          }
        });

        // Return back scroll to body if no more modal showed up
        if (getHighestZindex() == 9999) {
          cash("body")
            .removeClass("overflow-y-hidden")
            .css("padding-right", "");
        }

        // Return back modal element to it's first place
        cash('[data-modal-replacer="' + cash(el).attr("id") + '"]').replaceWith(
          el
        );
      }, transitionDuration);

      // Trigger callback function
      events.forEach(function (val, key) {
        if (
          cash(el).attr("id") == cash(val.el).attr("id") &&
          val.event == "on.hide"
        ) {
          events[key].triggerCallback = true;
        }
      });
    }
  }

  // Toggle modal
  function toggle(el) {
    if (cash(el).hasClass("modal") && cash(el).hasClass("show")) {
      hide(el);
    } else {
      show(el);
    }
  }

  // On show
  function onShow(el, callback) {
    events[events.length] = {
      el: el,
      event: "on.show",
      triggerCallback: false,
      callback: callback,
    };
  }

  // On hide
  function onHide(el, callback) {
    events[events.length] = {
      el: el,
      event: "on.hide",
      triggerCallback: false,
      callback: callback,
    };
  }

  function onSubmit(pristine,modal,component,component_index,component_fct) {
        let valid = pristine.validate();
        let form_obj = cash(modal).find('form');
        console.log('Form Obj');
        console.log(form_obj);
        if (valid) {
            let fd = new FormData(form_obj[0]);
            console.log('Form Data:');
            console.log(fd);
            window.axios.post(form_obj.attr('action'),fd)
            .then( function(response){
                let notification = cash("#success-notification").clone();
                // console.log('Form Submit Response:');
                // console.log(response)
                // console.log('Noti content');
                // console.log(cash("#success-notification").find('.notification-title'));
                if ( typeof response.data.title != 'undefined'){
                    notification.find('.notification-title').html(response.data.title);
                }
                if ( typeof response.data.content != 'undefined'){
                    notification.find('.notification-content').html(response.data.content);
                }

                feather.replace();
                Toastify({
                    node: notification.removeClass("hidden")[0],
                    duration: 3000,
                    newWindow: true,
                    close: true,
                    gravity: "top",
                    position: "right",
                    stopOnFocus: true,
                }).showToast();

                hide(modal);
                if (typeof component !== 'undefined' && component !== false) {
                    if( component_fct == 'refresh'){
                        Livewire.components.getComponentsByName(component)[component_index].$wire.$refresh()
                    }
                    if( component_fct == 'add_product'){
                        Livewire.components.getComponentsByName(component)[component_index].$wire.addProduct(response.data.id)
                    }
                }
            }).catch(function (error) {
                // handle error
                console.log('Form Submit Error');
                console.log(error.response);
                let notification = cash("#failed-notification").clone();

                if ( typeof error.response.data.title != 'undefined'){
                    notification.find('.notification-title').html(error.response.data.title);
                }
                if ( typeof error.response.data.content != 'undefined'){
                    notification.find('.notification-content').html(error.response.data.content);
                }
                feather.replace();
                // Show error on each input
                Toastify({
                    node: notification.removeClass("hidden")[0],
                    duration: 3000,
                    newWindow: true,
                    close: true,
                    gravity: "top",
                    position: "right",
                    stopOnFocus: true,
                }).showToast();
            });

        } else {
            Toastify({
                node: cash("#failed-notification")
                    .clone()
                    .removeClass("hidden")[0],
                duration: 3000,
                newWindow: true,
                close: true,
                gravity: "top",
                position: "right",
                stopOnFocus: true,
            }).showToast();
        }
    }

    function initForm(el,component,component_index,component_fct){
        let modal_inside;
        let target;
        if(cash(el).hasClass('modal')){
            modal_inside = cash(el)
            .find('.modal-content');
            target = el;
        }else{
            modal_inside = cash(cash(el).attr("data-target"))
            .find('.modal-content');
            target = cash(el).attr("data-target");
        }

        let form = modal_inside.find('form.validate-form');
        console.log('Init Form');
        console.log(form);

        modal_inside.find('.tom-select').each(function(index,element){
            new TomSelect(element);
        });

        if( form.length ){
            if( form.attr('data-initialized') != "true" ){
                let pristine = new Pristine(form[0], {
                    classTo: "input-form",
                    errorClass: "has-error",
                    errorTextParent: "input-form",
                    errorTextClass: "text-theme-24 mt-2",
                });
                console.log('after pristine');
                form.off('submit');
                form.on("submit", function (e) {
                    console.log('Submit Form');
                    e.preventDefault();
                    onSubmit(pristine,target,component,component_index,component_fct);
                    return false;
                });
                form.attr('data-initialized',"true");
            }else{
                console.log('Form already Initialized');
            }

        }
    }

  function loadServerContent(el)
  {
    let endpoint = cash(el).attr('data-endpoint');
    let component = cash(el).attr('data-refreshlivewiretable');
    let component_index = cash(el).attr('data-refreshlivewiretable-index');
    console.log(endpoint);
    if (typeof endpoint !== 'undefined' && endpoint !== false) {
        window.axios.get(endpoint)
        .then(function (response) {
            // console.log(response)
            // handle success
            let modal_inside = cash(cash(el).attr("data-target"))
            .find('.modal-content');

            modal_inside.html(response.data);

            initForm(el,component,component_index,'refresh');
            // console.log(response);
        }).catch(function (error) {
            // handle error
            console.log(error);
        });
    }
  }

  function hideDropdown(el)
  {
    let dropdown = cash('.dropdown-menu.show');
    console.log('Hide Dropdown');
    console.log(dropdown);
    if ( dropdown.length ){
        dropdown.dropdown('hide');
    }
  }
  // Show modal
  cash("body").on("click", 'a[data-toggle="modal"]', function () {
        loadServerContent(this);
        show(cash(this).attr("data-target"));
        hideDropdown(this);
  });

  // Hide modal
  cash("body").on("click", function (event) {
    if (
      cash(event.target).hasClass("modal") &&
      cash(event.target).hasClass("show")
    ) {
      // Check if modal backdrop is not static
      if (cash(event.target).data("backdrop") === undefined) {
        hide(event.target);
      } else {
        cash(event.target).addClass("modal-static");
        setTimeout(() => {
          cash(event.target).removeClass("modal-static");
        }, 600);
      }
    }
  });

  // Dismiss modal by link
  cash("body").on("click", '[data-dismiss="modal"]', function () {
    let modal = cash(this).closest(".modal")[0];
    hide(modal);
  });

  // Detect show or hide event
  setInterval(function () {
    events.forEach(function (val, key) {
      if (val.event == "on.show" && val.triggerCallback) {
        val.callback();
        events[key].triggerCallback = false;
      } else if (val.event == "on.hide" && val.triggerCallback) {
        val.callback();
        events[key].triggerCallback = false;
      }
    });
  }, 300);

  // Keyboard event
  document.addEventListener("keydown", function (event) {
    if (event.code == "Escape") {
      let el = cash(".modal.show").last();
      if (cash(el).hasClass("modal") && cash(el).hasClass("show")) {
        // Check if modal backdrop is not static
        if (cash(el).data("backdrop") === undefined) {
          hide(el);
        } else {
          cash(el).addClass("modal-static");
          setTimeout(() => {
            cash(el).removeClass("modal-static");
          }, 600);
        }
      }
    }
  });

  cash.fn.modal = function (event, callback) {
    if (event == "show") {
      show(this);
    } else if (event == "hide") {
      hide(this);
    } else if (event == "toggle") {
      toggle(this);
    } else if (event == "on.show") {
      onShow(this, callback);
    } else if (event == "on.hide") {
      onHide(this, callback);
    }
  };
})(cash);
